import { ParcelamentoTypes } from './types';

interface FormPaymentProps {
  paymentType: number;
  servicosId: object;
  renewal: boolean;
}

export const getPackageService = ({ paymentType, servicosId, renewal }: FormPaymentProps) => ({
  types: [
    ParcelamentoTypes.GET_PARCELAMENTO_REQUEST,
    ParcelamentoTypes.GET_PARCELAMENTO_SUCCESS,
    ParcelamentoTypes.GET_PARCELAMENTO_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/api/controle_crm/dinamic_packages', {
      params: {
        body: { formas_pagamento_id: paymentType, servicos_planos_vendas: servicosId, renewal },
      },
    }),
});
